import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const SoftballGray = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Softball_Gray" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0711 19.0711C15.1658 22.9763 8.83419 22.9763 4.92894 19.0711C1.02369 15.1658 1.02369 8.83419 4.92894 4.92894C8.83419 1.02369 15.1658 1.02369 19.0711 4.92894C22.9763 8.83419 22.9763 15.1658 19.0711 19.0711Z"
                    fill="#E1E2ED"
                />
                <path
                    d="M1.35547 11.3199C4.53305 8.64132 9.25594 8.8305 12.2127 11.7873C15.1695 14.744 15.3587 19.4669 12.68 22.6445L11.1509 21.3555C13.1614 18.9705 13.0192 15.4222 10.7985 13.2015C8.57775 10.9807 5.02952 10.8386 2.64452 12.8491L1.35547 11.3199Z"
                    fill="#54586A"
                />
                <path
                    d="M14.4348 2.49562C14.8084 4.21431 15.6622 5.79361 16.9343 7.06567C18.2064 8.33773 19.7857 9.19153 21.5044 9.56515L21.0795 11.5195C18.9888 11.065 17.0654 10.0252 15.5201 8.47988C13.9748 6.9346 12.935 5.01117 12.4805 2.92047L14.4348 2.49562Z"
                    fill="#54586A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.22183 19.7782C-0.0739441 15.4824 -0.0739441 8.51761 4.22183 4.22183C8.51761 -0.0739441 15.4824 -0.0739441 19.7782 4.22183C24.0739 8.51761 24.0739 15.4824 19.7782 19.7782C15.4824 24.0739 8.51761 24.0739 4.22183 19.7782ZM18.364 18.364C21.8787 14.8492 21.8787 9.15077 18.364 5.63605L18.1547 5.43335C14.6266 2.12267 9.08186 2.19023 5.63605 5.63605C2.12132 9.15077 2.12132 14.8492 5.63605 18.364C9.15077 21.8787 14.8492 21.8787 18.364 18.364Z"
                    fill="#0A0B0D"
                />
            </g>
        </svg>
    );
};
